import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { JOIN_TO_EXERCISE } from "../../../../../api/apiRoutes";
import { Ticket } from "../../../../../models/Ticket";
import { SwimmingLesson } from "../../../../../models/SwimmingScheduleData";
import { State } from "../../../../../store";
import { setSuccessMessage } from "../../../../../store/alerts/alertsActions";
import { errorMessageFromApi, UNKNOWN_ERROR } from "../../../../../utils/apiErrorMessages";
import useApiRequest from "../../../../../../utils/hooks/useApiRequest";
import useFacility from "../../../../../../utils/hooks/useFacility";
import getId from "../../../../../../utils/getId";

interface CatchUpLessonsBookingResult {
  ok: boolean;
  error: string;
}

export default function useCatchUpLessonsBooking() {
  const facilityIds = useFacility();
  const { post } = useApiRequest();
  const dispatch = useDispatch();
  const userDataId = useSelector((state: State) => state.auth.userData.objectId);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const bookCatchUpLesson = async (ticket: Ticket, lesson: SwimmingLesson): Promise<CatchUpLessonsBookingResult> => {
    if (isSubmitting) {
      return { ok: false, error: "" };
    }
    const passIds = getId(ticket);
    if (!passIds) {
      return { ok: false, error: UNKNOWN_ERROR };
    }

    setIsSubmitting(true);
    try {
      const joinResponse = await post(JOIN_TO_EXERCISE(facilityIds, passIds), {
        exerciseIds: lesson.objectId,
        webUserIds: `0,${userDataId}`,
        assigned: false,
      });
      if (joinResponse.isError) {
        return { ok: false, error: errorMessageFromApi(joinResponse) || UNKNOWN_ERROR };
      }
      dispatch(setSuccessMessage("Zapisano na lekcję do odrobienia."));
      return { ok: true, error: "" };
    } catch {
      return { ok: false, error: UNKNOWN_ERROR };
    } finally {
      setIsSubmitting(false);
    }
  };

  return { bookCatchUpLesson, isSubmitting };
}
